import { Action } from 'redux';
import * as Actions from './actionTypes';
import { ServiceContractRecordsFilters } from 'src/common/models/contract';
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions';
import { PayableContract, PayableContractRecordsFilters } from 'src/common/models/payableContract';

export interface GetPayableContractsAction extends Action {
    filters?: PayableContractRecordsFilters
}
export interface GetPayableContractsSuccessAction extends Action {
    payableContracts: PayableContract[]
}
export const getPayableContractsApi = (filters?: ServiceContractRecordsFilters): GetPayableContractsAction => ({
    type: Actions.GET_PAYABLE_CONTRACTS_API,
    filters,
})
export const getPayableContractsApiSuccess = (payableContracts: PayableContract[]): GetPayableContractsSuccessAction => ({
    type: Actions.GET_PAYABLE_CONTRACTS_API_SUCCESS,
    payableContracts,
})
export const getPayableContractsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_PAYABLE_CONTRACTS_API_ERROR,
    error,
)

export interface CreatePayableContractAction extends Action {
    payableContract: PayableContract
}
export interface CreatePayableContractSuccessAction extends Action {
    payableContract: PayableContract
}
export const createPayableContractApi = (payableContract: PayableContract): CreatePayableContractAction => ({
    type: Actions.CREATE_PAYABLE_CONTRACT_API,
    payableContract,
})
export const createPayableContractApiSuccess = (payableContract: PayableContract): CreatePayableContractSuccessAction => ({
    type: Actions.CREATE_PAYABLE_CONTRACT_API_SUCCESS,
    payableContract,
})
export const createPayableContractApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.CREATE_PAYABLE_CONTRACT_API_ERROR,
    error,
)

export interface GetPayableContractByIdAction extends Action {
    id: number
}
export interface GetPayableContractByIdSuccessAction extends Action {
    payableContract: PayableContract
}
export const getPayableContractByIdApi = (id: number): GetPayableContractByIdAction => ({
    type: Actions.GET_PAYABLE_CONTRACT_BY_ID_API,
    id,
})
export const getPayableContractByIdApiSuccess = (payableContract: PayableContract): GetPayableContractByIdSuccessAction => ({
    type: Actions.GET_PAYABLE_CONTRACT_BY_ID_API_SUCCESS,
    payableContract,
})
export const getPayableContractByIdApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_PAYABLE_CONTRACT_BY_ID_API_ERROR,
    error,
)

export const cleanCurrentPayableContract = (): Action => ({
    type: Actions.CLEAN_CURRENT_PAYABLE_CONTRACT,
});

export interface UpdatePayableContractAction extends Action {
    payableContract: PayableContract
}
export interface UpdatePayableContractSuccessAction extends Action {
    payableContract: PayableContract
}
export const updatePayableContractApi = (payableContract: PayableContract): UpdatePayableContractAction => ({
    type: Actions.UPDATE_PAYABLE_CONTRACT_API,
    payableContract,
})
export const updatePayableContractApiSuccess = (payableContract: PayableContract): UpdatePayableContractSuccessAction => ({
    type: Actions.UPDATE_PAYABLE_CONTRACT_API_SUCCESS,
    payableContract,
})
export const updatePayableContractApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPDATE_PAYABLE_CONTRACT_API_ERROR,
    error,
)